"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOption = exports.Editor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const dropdown_1 = require("primereact/dropdown");
const floatlabel_1 = require("primereact/floatlabel");
const DragAndDropImage_1 = require("../../components/web-view/drag-and-drop/DragAndDropImage");
const GenericButton_1 = require("../../components/web-view/button/GenericButton");
const useToast_1 = require("../../hooks/toast/useToast");
const useIsMobile_1 = require("../../hooks/mobile/useIsMobile");
const ApiProductRepo_1 = require("../../modules/product/infra/ApiProductRepo");
const ApiImageRepo_1 = require("../../modules/images/infra/ApiImageRepo");
const ApiCategoryRepo_1 = require("../../modules/categories/infra/ApiCategoryRepo");
const createProduct_1 = require("../../modules/product/app/createProduct");
const updateProduct_1 = require("../../modules/product/app/updateProduct");
const uploadImage_1 = require("../../modules/images/app/uploadImage");
const constants_1 = require("../../routes/constants");
const lia_1 = require("react-icons/lia");
const BiPurchaseTagAlt_1 = require("@react-icons/all-files/bi/BiPurchaseTagAlt");
const ValidatedInput_1 = require("./ValidatedInput");
const ai_1 = require("react-icons/ai");
const apiProductRepo = (0, ApiProductRepo_1.createApiProductRepo)();
const apiImageRepo = (0, ApiImageRepo_1.createApiImageRepo)();
const apiCategoryRepo = (0, ApiCategoryRepo_1.createApiCategoryRepo)();
const FormBody = ({ id, thumbnailUrl, handleDrop, control, categories, isMobile, t, navigate, isSubmitting, isSubmitted, }) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ImageUpload, { label: t('image'), thumbnailUrl: thumbnailUrl, handleDrop: handleDrop }), (0, jsx_runtime_1.jsxs)("div", { className: isMobile ? 'w-full mt-10' : 'w-1/3 mt-10', children: [(0, jsx_runtime_1.jsx)(ValidatedInput_1.ValidatedInput, { id: "name", label: t('name'), type: "text", options: {
                            required: t('validation.nameRequired'),
                            placeholder: t('name'),
                        }, control: control, isSubmitted: isSubmitted, leftAddon: (0, jsx_runtime_1.jsx)(ai_1.AiOutlineForm, { className: "text-3xl" }) }), (0, jsx_runtime_1.jsx)(ValidatedInput_1.ValidatedInput, { id: "weight", label: t('weight'), type: "number", options: {
                            required: t('validation.weightRequired'),
                            min: 0,
                            placeholder: t('weight'),
                        }, control: control, isSubmitted: isSubmitted, leftAddon: (0, jsx_runtime_1.jsx)(lia_1.LiaWeightSolid, { className: "text-3xl" }), rightAddon: "g" }), (0, jsx_runtime_1.jsx)(ValidatedInput_1.ValidatedInput, { id: "retailPrice", label: t('price'), type: "number", options: {
                            required: t('validation.priceRequired'),
                            min: 0,
                            placeholder: t('price'),
                        }, control: control, isSubmitted: isSubmitted, leftAddon: "\u20AC" }), (0, jsx_runtime_1.jsx)(ValidatedInput_1.ValidatedInput, { id: "purchaseCost", label: t('purchaseCost'), type: "number", options: {
                            required: t('validation.purchaseCostRequired'),
                            min: 0,
                            placeholder: t('purchaseCost'),
                        }, control: control, isSubmitted: isSubmitted, leftAddon: (0, jsx_runtime_1.jsx)(BiPurchaseTagAlt_1.BiPurchaseTagAlt, { className: "text-3xl" }) }), (0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { control: control, name: "customCode", rules: {
                            required: {
                                value: true,
                                message: t('validation.categoryRequired'),
                            },
                        }, render: ({ field, fieldState }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(floatlabel_1.FloatLabel, { children: [(0, jsx_runtime_1.jsx)(dropdown_1.Dropdown, { ...field, options: categories, optionLabel: "label", optionValue: "value", required: true, onChange: (e) => {
                                                field.onChange(e.value);
                                            }, className: `flex items-center w-full pl-4 rounded-3xl border border-gray-300 ${fieldState.error ? 'p-invalid' : ''}` }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "customCode", children: t('selectCategory') })] }), fieldState.error && (isSubmitted || fieldState.isTouched) && ((0, jsx_runtime_1.jsx)("p", { className: "text-red-500 text-xs mt-1", children: fieldState.error.message }))] })) })] }), (0, jsx_runtime_1.jsxs)("div", { className: `${isMobile ? 'mt-20 pb-32' : 'mt-20 pb-10'} flex justify-center items-center`, children: [(0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { className: "cancelButtonModal mr-20", type: "button", label: t('back'), onClick: () => navigate(constants_1.ROUTE_PRODUCTS_LIST), disabled: isSubmitting }), (0, jsx_runtime_1.jsx)(GenericButton_1.GenericButton, { className: "acceptButtonModal", type: "submit", label: isSubmitting ? t('sending') : id ? t('edit') : t('create'), disabled: isSubmitting })] })] }));
};
// ============================================================================
// --- Componente Principal `Editor` ---
// ============================================================================
const Editor = ({ id }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [thumbnailUrl, setThumbnailUrl] = (0, react_1.useState)();
    const [categories, setCategories] = (0, react_1.useState)([]);
    const { showError } = (0, useToast_1.useToast)();
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const { handleSubmit, formState: { isSubmitting, isSubmitted }, setValue, reset, control, } = (0, react_hook_form_1.useForm)({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        defaultValues: {
            name: '',
            weight: undefined,
            retailPrice: undefined,
            purchaseCost: undefined,
            customCode: 'other',
            thumbnailUrl: '',
            imgUrl: '',
        },
    });
    (0, react_1.useEffect)(() => {
        if (!id)
            return;
        const loadProduct = async () => {
            try {
                const product = await apiProductRepo.getById(id);
                if (product) {
                    reset({
                        ...product,
                        weight: product.weight || 0,
                        retailPrice: product.retailPrice || 0,
                    });
                    setThumbnailUrl(product.thumbnailUrl);
                }
            }
            catch {
                showError(t('error.loadingProduct'));
            }
        };
        loadProduct();
    }, [id]);
    (0, react_1.useEffect)(() => {
        const loadCategories = async () => {
            try {
                const loadedCategories = await apiCategoryRepo.getAll();
                const translatedCategories = loadedCategories.map((category) => ({
                    label: t(`${category}`),
                    value: category,
                }));
                setCategories(translatedCategories);
            }
            catch {
                showError(t('error.loadingCategories'));
            }
        };
        loadCategories();
    }, []);
    const handleDrop = async (files) => {
        if (files.length === 0)
            return;
        const file = files[0];
        try {
            const img = new Image();
            const reader = new FileReader();
            reader.onload = () => {
                img.src = reader.result;
            };
            reader.readAsDataURL(file);
            img.onload = async () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                if (ctx) {
                    const maxWidth = 1024;
                    const maxHeight = 1024;
                    let { width, height } = img;
                    if (width > maxWidth || height > maxHeight) {
                        const ratio = Math.min(maxWidth / width, maxHeight / height);
                        width *= ratio;
                        height *= ratio;
                    }
                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);
                    const compressImage = (canvasEl, quality) => new Promise((resolve) => {
                        canvasEl.toBlob((blob) => {
                            if (blob && blob.size <= 100 * 1024)
                                resolve(blob);
                            else if (quality > 0.1)
                                resolve(compressImage(canvasEl, quality - 0.05));
                            else
                                resolve(blob);
                        }, file.type, quality);
                    });
                    const compressedBlob = await compressImage(canvas, 0.9);
                    if (compressedBlob) {
                        const resizedFile = new File([compressedBlob], file.name, {
                            type: file.type,
                            lastModified: file.lastModified,
                        });
                        const uploadedImage = await (0, uploadImage_1.uploadImage)(apiImageRepo, resizedFile);
                        setValue('thumbnailUrl', uploadedImage.url, {
                            shouldValidate: true,
                        });
                        setValue('imgUrl', uploadedImage.url, { shouldValidate: true });
                        setThumbnailUrl(uploadedImage.url);
                    }
                    else {
                        showError(t('error.uploadingImage'));
                    }
                }
            };
        }
        catch {
            showError(t('error.uploadingImage'));
        }
    };
    const onSubmit = async (data) => {
        if (id) {
            try {
                await (0, updateProduct_1.updateProduct)(apiProductRepo, data);
                navigate(constants_1.ROUTE_PRODUCTS_LIST);
            }
            catch (error) {
                showError(t('error.editingProduct'));
            }
        }
        else {
            try {
                await (0, createProduct_1.createProduct)(apiProductRepo, data);
                navigate(constants_1.ROUTE_PRODUCTS_LIST);
            }
            catch {
                showError(t('error.creatingProduct'));
            }
        }
    };
    return ((0, jsx_runtime_1.jsx)("form", { onSubmit: handleSubmit(onSubmit), className: `flex flex-col items-center w-11/12 mx-auto bg-transparent z-10 ${isMobile ? 'mt-24' : 'mt-10'}`, children: (0, jsx_runtime_1.jsx)(FormBody, { id: id, thumbnailUrl: thumbnailUrl, handleDrop: handleDrop, control: control, categories: categories, isMobile: isMobile, isSubmitting: isSubmitting, t: t, navigate: navigate, isSubmitted: isSubmitted }) }));
};
exports.Editor = Editor;
const ImageUpload = ({ thumbnailUrl, handleDrop }) => ((0, jsx_runtime_1.jsx)("div", { className: "w-full flex justify-center items-center", children: (0, jsx_runtime_1.jsx)(DragAndDropImage_1.DragAndDropImage, { imgUrl: thumbnailUrl, uploadImage: handleDrop }) }));
const parseOption = (option) => typeof option === 'string' ? parseFloat(option) : option;
exports.parseOption = parseOption;
